import React, { ChangeEventHandler, KeyboardEvent } from 'react';
import { LabeledInput } from 'components/Shared/Form/LabeledInput/themes/BGH';
import { rm } from 'utils';
import { LoadingStatus } from 'models/LoadingStatus';
import { ZIP_CODE_LENGTH, isValidZipcode } from './themes/BGH/validation';
import { getQaDataAttr } from '@bygghemmait/utilities';

interface ZipProps {
  title: string;
  description: string;
  loadingStatus?: LoadingStatus;
  onChange: ChangeEventHandler<HTMLInputElement>;
  zipCode: string;
  inputClassName: string;
  descriptionClassName: string;
  onClear?: () => void;
}

const allowedInputRegex = /\d|\s/;

const onKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
  const input = event.key;
  const isAllowedInput = allowedInputRegex.test(input);

  if (!isAllowedInput) {
    event.preventDefault();
  }
};

export const ZipCodeInput = ({
  title,
  description,
  loadingStatus,
  onChange,
  zipCode,
  inputClassName,
  descriptionClassName,
  onClear
}: ZipProps) => {
  return (
    <>
      <p className={descriptionClassName}>{description}</p>
      <LabeledInput
        label={rm('zip_input')}
        className={inputClassName}
        title={title}
        loading={loadingStatus === LoadingStatus.Fetching}
        max={ZIP_CODE_LENGTH}
        onChange={onChange}
        invalid={zipCode.length > 0 && !isValidZipcode(zipCode)}
        value={zipCode}
        onKeyPress={onKeyPress}
        onClear={onClear}
        inputMode="numeric"
        {...getQaDataAttr('installation-zipcode-input')}
      />
    </>
  );
};
